export function formatState(value) {
  if (value === 0) {
    return '正常'
  } else {
    return '禁用'
  }
}

export function test() {
  return 'XXXX'
}
